import type { IUser } from "../hooks/useUser";

export const ALREADY_LOGGEDIN = () => "/user/alreadyLogin";
export const LOGIN = () => "/auth/login";
export type TLoginResponse =
  | {
      loginByIdToken: string;
      users: Partial<IUser>[];
      accessToken: undefined;
      refreshToken: undefined;
    }
  | {
      loginByIdToken: undefined;
      users: undefined;
      accessToken: string;
      refreshToken: string;
    };
export const LOGOUT = () => "/user/logout";
export const SELECT_USER = () => "/auth/selectUser";
export const SIGN_UP = () => "/user/signUp";
export const VERIFY_CODE = () => "/auth/verifyOtp";
export const RESEND_CODE = () => "/user/sendVerificationCode";
export const CHANGE_PASSWORD = () => "/user/changePassword";
export const REFRESH_TOKEN = () => "/auth/refresh";
export const GET_USER = () => "/auth/user";
